import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { ChannelsService } from 'app/infrastructure/services/channels.service';
import { ItemGeneralListado } from 'app/helpers/components/itemClasses/itemListadoGeneral.class';
import { UsuariosService, VariableCircuitoIn } from 'app/infrastructure/services/usuarios.service';
import { RolesService } from 'app/infrastructure/services/roles.service';
import { Translator } from 'angular-translator';
import * as _ from 'lodash';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { UserWithRole, UsersByRoleRequest } from 'app/infrastructure/model/interfaces/role.interfaces';

@Component({
  selector: 'app-users-by-role',
  templateUrl: 'users.by.role.component.html'
})

export class UsersByRoleComponent implements OnInit {

  // Required for .html
  obj = Object;

  systemCode: string;

  businesses: ItemGeneralListado[];
  businessCode: string;

  roles: Role[];
  selectedRole: string;

  adminUser: string;
  allUsers: { [id: string]: VariableCircuitoIn };
  selectedUser: string;
  usersWithRoles: { [id: string]: UserWithRole };
  usersToShow: { [id: string]: UserWithRole };

  @Input() updateUsers: EventEmitter<any>;

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private channelsSrv: ChannelsService,
              private userSrv: UsuariosService,
              private roleSrv: RolesService,
              private translator: Translator,
              private alertService: AlertService) { }

  ngOnInit() {
    this.systemCode = this.aRoute.snapshot.params.codsistema;
    if(this.systemCode==undefined)
      this.systemCode = "null";
    this.businessChange(this.aRoute.snapshot.params.codnegocio);

    this.updateUsers.subscribe(_ => this.update());
  }


  resetRoles() {
    this.roles = undefined;
    this.selectedRole = undefined;
    this.resetUsers();
  }

  businessChange(newBusiness: string) {
    if(newBusiness==undefined)
      newBusiness ="null";
    this.businessCode = newBusiness;
    if (newBusiness) {
        this.resetRoles();
        this.roleSrv.getRolesByContext(this.systemCode, this.businessCode)
                    .toPromise()
                    .then(roles => this.roles = roles);
    }
  }

  resetUsers() {
    this.allUsers = undefined;
    this.selectedUser = undefined;
    this.usersWithRoles = undefined;
    this.usersToShow = undefined;
  }

  roleChange(newRoleCode: string) {
    this.selectedRole = newRoleCode;
    if (newRoleCode) {
      if(this.systemCode==undefined)
        this.systemCode ="null";
      if(this.businessCode==undefined)
        this.businessCode = "null";
      this.roleSrv.getUsersByRole(this.systemCode, this.businessCode, newRoleCode)
                  .then(response => {
                    this.adminUser = response.adminUser;
                    const allUsersDict = {};
                    response.allUsers.forEach(user =>
                      allUsersDict[user.codigo] = user);
                    this.allUsers = allUsersDict;
                    this.selectedUser = undefined;
                    const usersWithRoleDict = {};
                    response.usersWithRole.forEach(userWithRole =>
                      usersWithRoleDict[userWithRole.userId] = userWithRole);
                    this.usersWithRoles = usersWithRoleDict;
                    this.usersToShow = _.clone(this.usersWithRoles);
                  });
    }
  }

  addUser(userId: string) {
    if (userId) {
      let userWithRole = this.usersWithRoles[userId];
      if (!userWithRole) {
        userWithRole = { 
          userId: userId,
          userName: this.allUsers[userId].valor,
          email: '',
          adminUser: this.adminUser,
          assignedDate: new Date()
        } as UserWithRole;
        this.usersWithRoles[userId] = userWithRole;
      }
      this.usersToShow[userId] = userWithRole;
    }
  }

  removeUser(userId: string) {
      delete this.usersToShow[userId];
  }

  update() {
    const userIdsToSend = Object.keys(this.usersToShow);
    const req = {
      adminUser: this.adminUser,
      userIds: userIdsToSend,
      roleCode: this.selectedRole
    } as UsersByRoleRequest;

    this.roleSrv.updateUsersByRole(this.systemCode, this.businessCode, req)
                .then(_ => {
                  this.alertService.showGrowl({
                    body: 'SUCCESS_USER_ROLE_SAVE',
                    type: GrowlType.SUCCESS,
                  });
                })
                .catch(reason => {
                  this.alertService.showGrowl({
                    body: reason,
                    type: GrowlType.DANGER,
                  });
                });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usersAndProfiles/user-roles/users.by.role.component.ts